import React from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { change as changeFieldValue, formValueSelector, reduxForm } from 'redux-form';
import { showSuccessMsg } from '../../util/messagesUtil';
import cadastrarRegraControleEmissaoBpe from '../../actions/bpe/cadastrarRegraControleEmissaoBpe';
import buscarEmpresaPorId from '../../actions/empresa/buscarEmpresaPorId';
import { tipoControleEmissaoBPe } from '../../util/constantsUtil';
import $ from 'jquery';
import ReactTooltip from 'react-tooltip';

export class ModalPainelRegraControleEmissaoBpe extends React.Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.limparFormulario = this.limparFormulario.bind(this);
  }

  limparFormulario() {
    this.props.reset('formularioPainelRegraControleEmissaoBpe');
  }

  limparCampos() {
    this.props.limparCheckedTipoControle();
  }

  submit() {
    this.props.cadastrarRegraControleEmissaoBpe(this.montarParametroControle()).then(() => {
      showSuccessMsg('Regra Controle Emissao Bpe salva com sucesso');
      this.limparCampos();
      this.props.buscarConfiguracoesBPe();
      this.props.buscarEmpresaPorId(this.props.codigoEmpresaSelecionada);
      this.fecharModal();
    })
  }

  fecharModal() {
    $('#modalPainelRegraControleEmissaoBpe')
      .modal('hide');
    $('#modalPainelRegraControleEmissaoBpe')
      .hide();
    $('.modal-backdrop')
      .hide();
    this.limparFormulario();
  }

  montarParametroControle() {
    return {
      idEmpresa: this.props.codigoEmpresaSelecionada,
      tipoControleEmissaoBPe: this.props.tipoControleBpeSelecionado
    };
  }

  exibirIconeAjudaRegra(tipoControle, tooltipId, tooltipContent) {
    return (
      <span className="align-self-center tooltip-info">
        <a data-tip data-for={tooltipId}>
          <i className="material-icons ajuda-icon" style={{ color: '#000' }}>help</i>
        </a>
        <div className="tooltip-ut">
          <ReactTooltip className="tooltip-ut" id={tooltipId} type="dark" effect="solid">
            <div className="row">{tooltipContent}</div>
          </ReactTooltip>
        </div>
      </span>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <div className="modal fade show" id='modalPainelRegraControleEmissaoBpe' role='dialog'
        aria-labelledby='modalPainelRegraControleEmissaoBpe' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-lg'}>
          <div className="modal-content">
            <div className="modal-header">
              <h5>Painel Selecionar Regra Controle Emissão BPe</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                onClick={this.limparFormulario}>
                <i className="material-icons">
                  close
                </i>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(this.submit)}>
                <div className="form-row">
                  <div className="col-12">
                    <div className="form-row mt-2">
                      <div>
                        <label>Tipo de Controle de Emissão BPe</label>
                        <div>
                          <div className='form-group form-check'>
                            <input type="radio" name='tipoContole'
                              style={{ cursor: 'pointer' }}
                              id={tipoControleEmissaoBPe.padrao.value}
                              className='form-check-input' onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.padrao.value)}
                              value={tipoControleEmissaoBPe.padrao.value}
                              checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.padrao.value} />
                            <label htmlFor={tipoControleEmissaoBPe.padrao.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.padrao.label}</label>
                            {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.padrao.value, 'regraPadrao', 'Configuração original existente, respeitando ativo e inativo empresa e estados.')}
                          </div>
                          <div className='form-group form-check'>
                            <input type="radio" name='tipoContole'
                              style={{ cursor: 'pointer' }}
                              id={tipoControleEmissaoBPe.horario.value}
                              className='form-check-input' onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.horario.value)}
                              value={tipoControleEmissaoBPe.horario.value}
                              checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.horario.value} />
                            <label htmlFor={tipoControleEmissaoBPe.horario.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.horario.label}</label>
                            {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.horario.value, 'regraHorario', 'Será transmitido somente nos horários marcados na tabela.')}
                          </div>
                          <div className='form-group form-check'>
                            <input type="radio" name='tipoContole'
                              style={{ cursor: 'pointer' }}
                              id={tipoControleEmissaoBPe.cartao.value}
                              className='form-check-input' onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.cartao.value)}
                              value={tipoControleEmissaoBPe.cartao.value}
                              checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.cartao.value} />
                            <label htmlFor={tipoControleEmissaoBPe.cartao.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.cartao.label}</label>
                            {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.cartao.value, 'regraCartao', 'Transmitir BPe em todas vendas de cartão.')}
                          </div>
                          <div className='form-group form-check'>
                            <input type="radio" name='tipoContole'
                              style={{ cursor: 'pointer' }}
                              id={tipoControleEmissaoBPe.horarioMaisCartao.value}
                              className='form-check-input' onChange={() => this.props.checkedFieldTipoControle(tipoControleEmissaoBPe.horarioMaisCartao.value)}
                              value={tipoControleEmissaoBPe.horarioMaisCartao.value}
                              checked={this.props.tipoControleBpeSelecionado == tipoControleEmissaoBPe.horarioMaisCartao.value} />
                            <label htmlFor={tipoControleEmissaoBPe.horarioMaisCartao.value} style={{ cursor: 'pointer' }} className='form-check-label'>{tipoControleEmissaoBPe.horarioMaisCartao.label}</label>
                            {this.exibirIconeAjudaRegra(tipoControleEmissaoBPe.horarioMaisCartao.value, 'regrahorarioMaisCartao', 'Quando a regra do temporizador estiver ativa, se vender no cartão Independente do horário ela vai transmitir o bpe na venda.')}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit"
                    disabled={!this.props.tipoControleBpeSelecionado}
                    className="btn btn-laranja">
                    Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    tipoControle: formValueSelector('formularioPainelRegraControleEmissaoBpe')(state, 'tipoControle')
  }
}

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarRegraControleEmissaoBpe,
    buscarEmpresaPorId
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioPainelRegraControleEmissaoBpe'
})(ModalPainelRegraControleEmissaoBpe));